import { Component } from '@angular/core';
import {GameService} from "../../../services/game.service";
import {Subscription} from "rxjs";
import {Game} from "../../../models/game.class";



@Component({
  selector: 'app-recent-games',
  templateUrl: './recent-games.component.html',
  styleUrls: ['./recent-games.component.scss']
})
export class RecentGamesComponent {

  recentGames: Game[] = [];
  gamesSubs: Subscription;

  constructor(
    private gameService: GameService,
  ) {
    this.gamesSubs = this.gameService.getGames().subscribe(games=>{
      if (games && games.length){
        this.recentGames = this.gameService.getRecentGames(games)
      } else {
        //no games available
        this.recentGames = [];
      }
    })
  }

  ngOnDestroy(){
    this.gamesSubs?.unsubscribe();
  }




}
